import { encode } from "../encoder.js";
export class QueryHelper {
    constructor(entity, schema, context, variableInitCounter = 0) {
        Object.defineProperty(this, "entity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "schema", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "context", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "variableInitCounter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "quads", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "variableQuads", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.entity = entity;
        this.schema = schema;
        this.context = context;
        this.variableInitCounter = variableInitCounter;
    }
    getQuads() {
        if (!this.quads) {
            this.quads = encode(this.entity, this.schema, this.context, this.variableInitCounter);
        }
        return this.quads;
    }
    getVariableQuads() {
        if (!this.variableQuads) {
            this.variableQuads = encode(this.getEntityWithReplacedVariables(), this.schema, this.context, this.variableInitCounter);
        }
        return this.variableQuads;
    }
    getDeleteQuads() {
        return this.getVariableQuads().filter((quad) => quad.object.termType === "Variable");
    }
    getInsertQuads() {
        return this.getQuads();
    }
    getWhereQuads() {
        return this.getVariableQuads();
    }
    getEntityWithReplacedVariables() {
        return this.replaceVariables(this.entity, this.schema);
    }
    replaceVariables(entity, schema) {
        return Object.keys(entity).reduce((output, key) => {
            const value = entity[key];
            if (key === "$id") {
                output.$id = value;
                return output;
            }
            if (key === "$type") {
                output.$type = value;
                return output;
            }
            const property = schema[key];
            if (!property) {
                throw new Error("Unknown field '${key}' detected in entity");
            }
            if (!property["@context"]) {
                output[key] = null;
                return output;
            }
            if (property["@array"]) {
                if (value.length === 0) {
                    output[key] = null;
                }
                else {
                    output[key] = value.map((subEntity) => this.replaceVariables(subEntity, property["@context"]));
                }
            }
            else {
                output[key] = this.replaceVariables(value, property["@context"]);
            }
            return output;
        }, {});
    }
}
